<template lang="pug">
  div
    v-alert.ml-2.mb-4(
      v-if="availableTypes.length < 2"
      color="primary"
      outlined text
    ) {{ COURSE_TYPES_TEXT[availableTypes[0]] }}
    api-form(
      v-model="value"
      :fields="fields"
      :method="save"
      :initial="initial"
      :autosave="!!course"
      :successCallback="successCallback"
      :btn-props="{ btnText: 'Создать курс' }"
      v-bind="$attrs"
    )

</template>

<script>
import SelectLevel from '@/components/InputFields/course/SelectLevel.vue';
import SelectCourseType from '@/components/InputFields/course/SelectCourseType.vue';
import SelectDirectionActivity from '@/components/InputFields/course/SelectDirectionActivity.vue';
import AutocompleateProfessional from '@/components/InputFields/course/AutocompleateProfessional.vue';
import AutocompleateSpecialities from '@/components/InputFields/course/AutocompleateSpecialities.vue';

import HintWrap from '@/components/HintWrap.vue';

import { COURSE_TYPE_NAMES, COURSE_TYPES_TEXT } from '@/utils/constants';

export default {
  name: 'CourseForm',
  props: {
    // Course.js model
    course: { type: Object, default: null },
    availableTypes: { type: Array, required: true },
  },
  data: () => ({
    COURSE_TYPES_TEXT,
    COURSE_TYPE_NAMES,
    value: {},
    initial: null,
  }),
  computed: {
    editMode() {
      return !!this.course;
    },
    fields() {
      return [
        {
          text: 'оффлайн курс',
          value: 'is_offline',
          component: 'v-checkbox',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Наименование',
          value: 'title',
          rules: 'required',
          component: 'v-textarea',
          component_attrs: {
            filled: true,
            rounded: true,
            'auto-grow': true,
            rows: 2,
            'row-height': 20,
            class: 'mb-5',
          },
        },
        {
          text: 'Краткое наименование',
          value: 'short_title',
          component: 'v-text-field',
          hidden: !this.editMode,
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Описание',
          value: 'description',
          component: 'v-textarea',
          hidden: !this.editMode,
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Форма обучения',
          value: 'education_form',
          component: 'v-select',
          component_attrs: {
            items: [{ value: 1, text: 'Очная' }, { value: 2, text: 'Очно-заочная' }, { value: 3, text: 'Заочная' }],
            filled: true,
            rounded: true,
          },
        },
        ...this.availableTypes.length < 2 ? [] : [{
          text: 'Тип курса',
          value: 'type',
          rules: 'required',
          component: SelectCourseType,
          component_attrs: {
            availableTypes: this.availableTypes,
            filled: true,
            rounded: true,
          },
        }],
        {
          text: 'Укрупненные группы специальностей',
          value: 'directory_specialities_group_id',
          component: AutocompleateSpecialities,
          hidden: this.value.type !== this.$conf.COURSE_TYPES.qualification,
        },
        {
          text: 'Наименование области профессиональной деятельности',
          value: 'directory_professional_activity_id',
          component: AutocompleateProfessional,
          hidden: this.value.type !== this.$conf.COURSE_TYPES.qualification,
        },
        {
          text: 'Наименование квалификации',
          value: 'qualification',
          component: 'v-text-field',
          hidden: this.value.type !== this.$conf.COURSE_TYPES.qualification,
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: '',
          value: 'directionActivity',
          component: SelectDirectionActivity,
          hidden: this.value.type !== this.$conf.COURSE_TYPES.general,
        },
        {
          text: 'Уровень сложности',
          value: 'level_type',
          component: SelectLevel,
          hidden: this.value.type !== this.$conf.COURSE_TYPES.general,
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Минимальный возраст обучающегося',
          value: 'age_min',
          component: 'v-text-field',
          hidden: !this.editMode || this.value.type !== this.$conf.COURSE_TYPES.general,
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Максимальный возраст обучающегося',
          value: 'age_max',
          component: 'v-text-field',
          hidden: !this.editMode || this.value.type !== this.$conf.COURSE_TYPES.general,
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Продолжительность обучения',
          value: 'duration',
          component: HintWrap,
          component_attrs: {
            component: 'v-text-field',
            hintDescription: !this.editMode ? 'Укажите ожидаемый объем курса в академических часах. Вы сможете позже изменить объем курса в его настройках' : 'Указывается в академических часах',
            filled: true,
            rounded: true,
            type: 'number',
          },
        },
        {
          text: '',
          value: 'price',
          component: HintWrap,
          component_attrs: {
            component: 'v-text-field',
            hintDescription: 'Цена за освоение курса',
            prefix: '₽',
            rounded: true,
            outlined: true,
            filled: true,
            placeholder: 'Цена в рублях',
            type: 'number',
          },
        },
      ];
    },
  },
  created() {
    if (this.course) {
      this.initial = this.course;
      this.value = this.course;
    }
    if (this.availableTypes.length < 2) {
      [this.value.type] = this.availableTypes;
    }
  },
  methods: {
    successCallback({ data }) {
      this.$toasted.success(`${this.course ? 'Успешно сохранено' : 'Курс создан'}`);
      if (!this.course) this.$router.push({ name: 'CourseUnits', params: { id: data.data.id } });
    },
    save({ data, obs }) {
      const payloads = { ...data };

      if (data.directionActivity) {
        Object.assign(payloads, { ...data.directionActivity });
        delete payloads.directionActivity;
      }

      if (this.course) {
        return this.course.update({ data: payloads, obs });
      }

      return this.$api.courses.create(payloads, obs);
    },
  },
};
</script>
